import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import Login from './pages/auth/Login';
import Dashboard from './pages/dashboard/Dashboard';
import Hotels from './pages/hotels/Hotels';
import HotelView from './pages/hotels/HotelView';
import HotelEdit from './pages/hotels/HotelEdit';
import HotelCreate from './pages/hotels/HotelCreate';
import Bookings from './pages/bookings/Bookings';
import BookingDetails from './pages/bookings/BookingDetails';
import EditBooking from './pages/bookings/EditBooking';
import Users from './pages/users/Users';
import UserDetails from './pages/users/UserDetails';
import UserForm from './pages/users/UserForm';
import BookingReports from './pages/reports/BookingReports';
import InventoryReports from './pages/reports/InventoryReports';
import HotelPerformanceReport from './pages/reports/HotelPerformanceReport';
import Layout from './components/layout/Layout';
import ProtectedRoute from './components/auth/ProtectedRoute';
import RoleProtectedRoute from './components/auth/RoleProtectedRoute';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/hotels" element={
              <RoleProtectedRoute allowedRoles={['Super Admin', 'Hotel Manager']}>
                <Layout>
                  <Hotels />
                </Layout>
              </RoleProtectedRoute>
            } />
            <Route path="/hotels/:id" element={
              <RoleProtectedRoute allowedRoles={['Super Admin', 'Hotel Manager']}>
                <Layout>
                  <HotelView />
                </Layout>
              </RoleProtectedRoute>
            } />
            <Route path="/hotels/:id/edit" element={
              <RoleProtectedRoute allowedRoles={['Super Admin', 'Hotel Manager']}>
                <Layout>
                  <HotelEdit />
                </Layout>
              </RoleProtectedRoute>
            } />
            <Route path="/hotels/new" element={
              <RoleProtectedRoute allowedRoles={['Super Admin', 'Hotel Manager']}>
                <Layout>
                  <HotelCreate />
                </Layout>
              </RoleProtectedRoute>
            } />
            <Route path="/bookings" element={
              <RoleProtectedRoute allowedRoles={['Super Admin', 'Booking Manager']}>
                <Layout>
                  <Bookings />
                </Layout>
              </RoleProtectedRoute>
            } />
            <Route path="/bookings/:id" element={
              <RoleProtectedRoute allowedRoles={['Super Admin', 'Booking Manager']}>
                <Layout>
                  <BookingDetails />
                </Layout>
              </RoleProtectedRoute>
            } />
            <Route path="/bookings/:id/edit" element={
              <RoleProtectedRoute allowedRoles={['Super Admin', 'Booking Manager']}>
                <Layout>
                  <EditBooking />
                </Layout>
              </RoleProtectedRoute>
            } />
            <Route path="/users" element={
              <RoleProtectedRoute allowedRoles={['Super Admin']}>
                <Layout>
                  <Users />
                </Layout>
              </RoleProtectedRoute>
            } />
            <Route path="/users/create" element={
              <RoleProtectedRoute allowedRoles={['Super Admin']}>
                <Layout>
                  <UserForm />
                </Layout>
              </RoleProtectedRoute>
            } />
            <Route path="/users/:id" element={
              <RoleProtectedRoute allowedRoles={['Super Admin']}>
                <Layout>
                  <UserDetails />
                </Layout>
              </RoleProtectedRoute>
            } />
            <Route path="/users/:id/edit" element={
              <RoleProtectedRoute allowedRoles={['Super Admin']}>
                <Layout>
                  <UserForm />
                </Layout>
              </RoleProtectedRoute>
            } />
            <Route path="/reports/bookings" element={
              <RoleProtectedRoute allowedRoles={['Super Admin', 'Reports Viewer']}>
                <Layout>
                  <BookingReports />
                </Layout>
              </RoleProtectedRoute>
            } />
            <Route path="/reports/inventory" element={
              <RoleProtectedRoute allowedRoles={['Super Admin', 'Reports Viewer']}>
                <Layout>
                  <InventoryReports />
                </Layout>
              </RoleProtectedRoute>
            } />
            <Route path="/reports/hotel-performance" element={
              <RoleProtectedRoute allowedRoles={['Super Admin', 'Reports Viewer']}>
                <Layout>
                  <HotelPerformanceReport />
                </Layout>
              </RoleProtectedRoute>
            } />
            <Route path="/" element={<Navigate to="/login" replace />} />
          </Routes>
        </div>
        </Router>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
